// extracted by mini-css-extract-plugin
export var headerXL = "Header-module--headerXL--3_dL9";
export var headerL = "Header-module--headerL--1w5mi";
export var headerM = "Header-module--headerM--3ajzu";
export var headerS = "Header-module--headerS--2f0bJ";
export var headerXS = "Header-module--headerXS--LjMQC";
export var blogHeaderXL = "Header-module--blogHeaderXL---qAiu";
export var blogHeaderL = "Header-module--blogHeaderL--2pof2";
export var blogHeaderM = "Header-module--blogHeaderM--3kr_N";
export var blogHeaderS = "Header-module--blogHeaderS--2OEQz";
export var blogHeaderXS = "Header-module--blogHeaderXS--3WXOU";
export var headerPreamble = "Header-module--headerPreamble--1AlhP";
export var preHeader = "Header-module--preHeader--1JxE3";
export var textNormal = "Header-module--textNormal--3nWEz";
export var textSmall = "Header-module--textSmall--3ONvF";
export var textSmallAlternate = "Header-module--textSmallAlternate--1cSjV";
export var legend = "Header-module--legend--2E9wH";
export var caption = "Header-module--caption--_QICm";
export var gradientBackground = "Header-module--gradientBackground--eqS4o";
export var ellipsis = "Header-module--ellipsis--vITYR";
export var globalContainer = "Header-module--globalContainer--64X82";
export var maxWidth = "Header-module--maxWidth--3s_Jf";
export var clipBottom = "Header-module--clipBottom--13IwA";
export var clipTopBottom = "Header-module--clipTopBottom--99a8l";
export var headerTransition = "Header-module--headerTransition--3u_is";
export var header = "Header-module--header--1_t8r";
export var headerContainer = "Header-module--headerContainer--3IA25";
export var logoContainer = "Header-module--logoContainer--3YR5h";
export var headerLogo = "Header-module--headerLogo--38qvv";
export var nav = "Header-module--nav--3pb5z";
export var collapsedHeader = "Header-module--collapsedHeader--1Z4hV";
export var menu = "Header-module--menu--mHe9H";
export var buttonsContainer = "Header-module--buttonsContainer--1Pi8C";
export var mobileNavButton = "Header-module--mobileNavButton--2JtCt";
export var mobileCloseButton = "Header-module--mobileCloseButton--1srEM";
export var mobileSideBar = "Header-module--mobileSideBar--12LGc";
export var mobileBar = "Header-module--mobileBar--29k_v";
export var mobileNav = "Header-module--mobileNav--1XZDZ";
export var mobileMenu = "Header-module--mobileMenu--2DqOy";
export var subMenu = "Header-module--subMenu--9qgn1";
export var subMenuTitle = "Header-module--subMenuTitle--2y1OH";
export var ch2 = "Header-module--ch2--1TP_1";
export var ch2Container = "Header-module--ch2-container--3KKIy";